import Typography from './Typography.js';
export { default } from './Typography.js';
//# sourceMappingURL=index.js.map
